const atom = require('recoil').atom;

module.exports = {
  generalChatIdState: atom({
    key: 'intelligenceGeneralChatIdState',
    default: null
  }),
  generalChatMessageIdState: atom({
    key: 'intelligenceGeneralChatMessageIdState',
    default: null
  }),
  generalChatPromptListState: atom({
    key: 'generalChatPromptListState',
    default: []
  }),
  generalChatActivePromptConversationsState: atom({
    key: 'generalChatActivePromptConversationsState',
    default: []
  }),
  generalChatLoading: atom({
    key: 'generalChatLoading',
    default: false
  }),
  generalChatGenerating: atom({
    key: 'generalChatGenerating',
    default: false
  }),
  generalChatActivePromptIdState: atom({
    key: 'generalChatActivePromptIdState',
    default: null
  })
};
